import { z } from 'zod';

export const otpSchema = z.object({
  code: z
    .string()
    .regex(/^[0-9]{6}$/, 'auth.errors.otpFormat'),
});

export type OtpFormValues = z.infer<typeof otpSchema>;
